import React from 'react';
import { format } from 'date-fns';

import styles from './voucher.module.scss';

type Props = {
  voucher: WebExperienceApiContract.Models.Voucher
};

const Voucher = ({ voucher }: Props) => {
  const { bottomText, expirationText, expiry, middleText, topText, uniqueDiscountLink } = voucher;

  if (!uniqueDiscountLink) return null
  return (
    <a
      href={uniqueDiscountLink}
      className="text-decoration-none"
    >
      <div className={styles.voucherWrap}>
        <div className={styles.ticket}>
          <div className={styles.ticketOutline} aria-hidden="true" />
          <div className={styles.ticketBody}>
            <div className={styles.eyeline}>{topText}</div>
            <strong className={styles.amount}>{middleText}</strong>
            <span className={styles.subline}>{bottomText}</span>
          </div>
        </div>
        <div className={styles.ticketFooter}>{expirationText} {format(new Date(expiry), 'dd/MM/yy')}</div>
      </div>
    </a>
  )
};

export default Voucher;
